export const DEFAULT_COLORS = [
  '#71966d',
  '#626262',
  '#679298',
  '#F88838',
  '#FFF7CF',
  '#EAE3F3',
  '#B8E6F2',
  '#FFB6C1',
  '#A2D2FF',
  '#FFD700',
];
export const COMPARE_COLORS = {
  primary: DEFAULT_COLORS[0],
  compare: DEFAULT_COLORS[1],
};

export const DEFAULT_DATASET_OPTIONS = {
  fill: false,
  tension: 0.4,
  borderWidth: 2,
  borderColor: COMPARE_COLORS.primary,
  backgroundColor: COMPARE_COLORS.primary,
  pointColor: COMPARE_COLORS.primary,
  pointBorderColor: COMPARE_COLORS.primary,
  pointBackgroundColor: COMPARE_COLORS.primary,
};

export const DEFAULT_CHART_OPTIONS: any['options'] = {
  interaction: {
    mode: 'index',
    intersect: false,
  },
  elements: {
    point: {
      radius: 0,
    },
  },
  plugins: {
    colors: {
      enabled: true,
    },
    legend: {
      display: true,
      position: 'bottom',
    },
    tooltip: {
      enabled: false,
      position: 'nearest',
    } as any,
  },
  scales: {
    y: {
      grid: {
        display: true,
      },
    },
    x: {
      beginAtZero: false,

      grid: {
        display: false,
      },
    },
  },
  datasets: {
    bar: {
      barThickness: 20,
      categoryPercentage: 1.0,
      barPercentage: 1.0,
      maxBarThickness: 20,
      borderWidth: 0,
    },
    line: {
      pointRadius: 0,
      tension: 0.4,
    },
  },
};
